import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=2cec9a6f&scoped=true&"
import script from "./Admin.vue?vue&type=script&lang=js&"
export * from "./Admin.vue?vue&type=script&lang=js&"
import style0 from "./Admin.vue?vue&type=style&index=0&id=2cec9a6f&prod&lang=css&"
import style1 from "./Admin.vue?vue&type=style&index=1&id=2cec9a6f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cec9a6f",
  null
  
)

export default component.exports